import React from "react";
import { getQuestionTypeLabel, isCorrectAnswerChoice } from "./claimViewUtils";

const ClaimQuestionViewOnly = ({ questions = [] }) => {
  if (!questions.length) {
    return (
      <div className="sectionpadding bg-white mb-30 claim-form-view-only-panel">
        <p className="release-document-view-empty mb-0">No questions available.</p>
      </div>
    );
  }

  return questions.map((question, index) => {
    const answerChoices = question?.answerChoice || [];
    const showChoices = question?.questionType !== "textField";

    return (
      <div
        className="sectionpadding bg-white mb-30 claim-form-view-only-panel"
        key={`${question?.questionText || "question"}-${index}`}
      >
        <div className="claim-form-view-only-meta">
          <div className="claim-form-view-only-field">
            <p className="claim-form-view-only-label">Select Question Type</p>
            <p className="claim-form-view-only-value mb-0">
              {getQuestionTypeLabel(question?.questionType)}
            </p>
          </div>
          {showChoices && (
            <div className="claim-form-view-only-field">
              <p className="claim-form-view-only-label">No. of Choices</p>
              <p className="claim-form-view-only-value mb-0">
                {question?.numberOfChoice || answerChoices.length || "-"}
              </p>
            </div>
          )}
        </div>

        <hr className="my-3" />

        <div className="claim-form-view-only-field mb-4">
          <p className="claim-form-view-only-label">Question</p>
          <p className="claim-form-view-only-value mb-0">
            {question?.questionText || "-"}
          </p>
        </div>

        {showChoices && (
          <div className="claim-form-view-only-field">
            <p className="claim-form-view-only-label">Answer Choices</p>
            <ul className="claim-form-view-only-choices p-0 mb-0">
              {answerChoices.map((choice, choiceIndex) => {
                const isCorrect = isCorrectAnswerChoice(
                  choice,
                  question?.correctAnswer,
                );

                return (
                  <li
                    className={`claim-form-view-only-choice${
                      isCorrect ? " claim-form-view-only-choice--correct" : ""
                    }`}
                    key={`${choice}-${choiceIndex}`}
                  >
                    <div className="claim-form-view-only-choice-content">
                      <span
                        className={`checkradiobtn d-inline-block claim-form-view-only-radio${
                          isCorrect ? " claim-form-view-only-radio--checked" : ""
                        }`}
                        aria-hidden="true"
                      />
                      <span>{choice}</span>
                    </div>
                    {isCorrect && (
                      <span
                        className="claim-form-view-only-tick-badge"
                        aria-hidden="true"
                      >
                        <span className="claim-form-view-only-tick-icon" />
                      </span>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        )}
      </div>
    );
  });
};

export default ClaimQuestionViewOnly;
